@if(infraestructures){
    <div class="grid">
        <div class="col-12">
            <h3 class="m-0" translate>infrastructure</h3>
        </div>
        <div class="col-12 relative" #mapContainer style="overflow: hidden;">
            <ng-container>
                <div class="list-button-float" *ngIf="!listMap">
                    <div class="circle-off"></div>
                    <button style="height:40px; width:40px;  background: black;" pButton pRipple type="button" icon="fas fa-list-ul" class="p-button-rounded p-button-secondary" (click)="listMap = true"></button>
                </div>
                <div class="container-list-map animate__animated animate__slideInRight" *ngIf="listMap">
                    <ng-container *ngIf="infraestructures.length === 0">
                        <div class="grid m-0 w-full h-full justify-content-end">
                            <div class="col-12 flex align-items-center flex-column justify-content-center" style="width: 50%;">
                                <span style="color: white; font-size: 18px; text-align: center;" translate>not_registered_infrastructures</span>
                                <button pButton pRipple type="button" label="{{'closeU' | translate}}" class="p-button-rounded p-button-danger mt-5 w-button" (click)="closeListMap()"></button>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="infraestructures.length > 0">
                        <div class="grid m-0">
                            <div class="col-12 text-right tex">
                                <div class="circle"></div>
                                <button style="margin-top: 5px; margin-right: 5px; height:40px; width:40px;" pButton pRipple type="button" icon="fas fa-times" class="p-button-rounded p-button-danger" (click)="closeListMap()"></button>
                            </div>
                            <div class="col-12">
                                <p-scrollPanel [style]="{width: '100%', height: '339px'}">
                                    <ng-container *ngFor="let item of infraestructures">
                                        <app-list-properties [type]="'SUMMARY'" [item]="item" (location)="openLocation(item)"></app-list-properties>
                                    </ng-container>
                                </p-scrollPanel>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
            <google-map height="465px" width="100%" [zoom]="zoom" [center]="center">
                <map-marker #somemarker="mapMarker" *ngFor="let item of infraestructures" [position]="item.position" (mapClick)="openInfo(somemarker, item)"></map-marker>
                <map-info-window>
                    <ng-container *ngIf="temporalInfraestructure">
                        <div style="width: 150px; flex-direction: column;" class="flex align-items-center flex-wrap text-center ">
                            <p class="m-0 text-blue-500 text-center">
                                <strong class="uppercase">{{temporalInfraestructure.name}}</strong>
                            </p>
                            <p class="m-0  text-center">
                                {{temporalInfraestructure.nameType}} -
                                {{temporalInfraestructure.area}}m2</p>
                            <p class="m-0 text-center">
                                <strong>{{temporalInfraestructure.address}}</strong>
                            </p>
                        </div>
                    </ng-container>
                </map-info-window>
            </google-map>
        </div>
    </div>
}